import { useInfo } from '../context/infoContext';
import { getTerminologiaRecorrencia } from '../utils/terminologiaRecorrencia';

/**
 * Hook centralizado para consumir a terminologia de recorrência resolvida pela API.
 *
 * @returns {ReturnType<typeof getTerminologiaRecorrencia>}
 */
export function useTerminologiaRecorrencia() {
  const { credorData } = useInfo();
  return getTerminologiaRecorrencia(credorData?.terminologia);
}

export default useTerminologiaRecorrencia;
